define(function(require,exports,module){
    var STRING = "string";
    return function(goats){
        var key,
            floated = {};
        for(key in goats){
            floated[key] = floated[key.toLowerCase()] = parseFloat(goats[key]);
        }
        return floated;
    }
});